import {JOB_STATE_COMPLETE, JOB_STATE_PROCESSING} from "../const/job.const";
import {EventBus} from "../events/event.bus";
import {EVENT_JOB_INIT_SUCCESS, EVENT_JOB_COMPLETE} from "../events/job.events";
import TabManager from "../manager/TabManager";
import JobManager from "../manager/JobManager";
import PreviewManager from "../manager/PreviewManager";

export default {
    props: {},
    data() {
        return {}
    },
    created: function () {
        let that = this;
        if (this.outputId === 'no_output_id') {
            EventBus.$on(EVENT_JOB_COMPLETE, (data) => {
                that.$router.replace({params: {outputid: data.apiJob.output[0].id}});
            });
        }
    },
    mounted: function () {
    },

    methods: {
    },
    computed: {
        id() {
            return this.$route.params.uuid;
        },
        outputId() {
            return this.$route.params.outputid;
        },
        currentJob() {
            return this.getJobById(this.id);
        },
        currentOutput() {
            return this.getOutputById(this.id, this.outputId);
        },
        loading() {
            return this.getJobById(this.id).state === JOB_STATE_PROCESSING;
        },
        complete() {
            return this.getJobById(this.id).isStateCompleted() === true;
        },
        downloadedOutputs() {
            if (!this.complete) {
                return [];
            }

            return this.getJobById(this.id).downloadedOutputs;
        },
        selectedOutputs() {
            if (!this.complete) {
                return [];
            }

            return this.getJobById(this.id).selectedOutputs;
        },
        isAllSelected() {
            if (!this.complete) {
                return false;
            }

            return this.getJobById(this.id).selectedOutputs.length === this.getJobById(this.id).apiJob.output.length;
        },
        isNoneSelected() {
            if (!this.complete) {
                return false;
            }

            return this.getJobById(this.id).selectedOutputs.length === 0;
        }
    }
}
